import { useEffect, useRef, useState } from "react";

export default function useReveal({
  threshold = 0.15,
  root = null,
  rootMargin = "0px",
} = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(node);
        }
      },
      { threshold, root, rootMargin }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold, root, rootMargin]);

  return [ref, inView];
}
